// Layout 相关的翻译资源（导航和语言选择器）
export const layoutResources = {
  zh: {
    'nav.title': '创生基金',
    // Navigation
    'nav.home': '首页',
    'nav.about': '关于我们',
    'nav.projects': '项目',
    'nav.news': '新闻',
    'nav.report': '公开报告',
    'nav.apply': '申请资助',
    'nav.apply.short': '申请',
    'nav.register': '立即报名',
    'nav.register.short': '报名',
    'nav.login': '立即登录',
    'nav.login.short': '登录',
    'nav.enterprise.overview': '评选首页',
    'nav.enterprise.companyInfo': '企业信息',
    'nav.enterprise.logout': '退出登录',
    'nav.familyFriendly': '家庭友好企业',
    'nav.postgraduate': '博士生资助',

    // Language selector
    'lang.simplified': '简',
    'lang.traditional': '繁',
    'lang.english': 'EN',

    // Footer
    'footer.copyright': '版权所有 © 2025 创生基金有限公司保留所有权利',
    'footer.followUs': '关注我们',
    'footer.privacy': '隐私政策',
    'footer.terms': '使用条款',
    'footer.cookie': 'Cookie政策',
    'footer.facebookAria': 'Facebook（新窗口打开）',
    'footer.youtubeAria': 'YouTube（新窗口打开）',
    'footer.promo.brandName': '家庭友好企业',
    'footer.promo.brandEn': 'Family-Friendly Employers',
    'footer.promo.slogan': '"寻找并致敬真正支持家庭、关爱社会的企业"',
    'footer.promo.org':
      '主办方：家庭友好企业评选组委会 · 联系邮箱 ffe-contact@genovationfoundation.org',
  },
  zh_TW: {
    'nav.title': '創生基金',
    // Navigation
    'nav.home': '首頁',
    'nav.about': '關於我們',
    'nav.projects': '項目',
    'nav.news': '新聞',
    'nav.report': '公開報告',
    'nav.apply': '申請資助',
    'nav.apply.short': '申請',
    'nav.register': '立即報名',
    'nav.register.short': '報名',
    'nav.login': '立即登入',
    'nav.login.short': '登入',
    'nav.enterprise.overview': '評選首頁',
    'nav.enterprise.companyInfo': '企業資訊',
    'nav.enterprise.logout': '退出登入',
    'nav.familyFriendly': '家庭友善企業',
    'nav.postgraduate': '博士生資助',

    // Language selector
    'lang.simplified': '简',
    'lang.traditional': '繁',
    'lang.english': 'EN',

    // Footer
    'footer.copyright': '版權所有 © 2025 創生基金有限公司保留所有權利',
    'footer.followUs': '關注我們',
    'footer.privacy': '隱私政策',
    'footer.terms': '使用條款',
    'footer.cookie': 'Cookie政策',
    'footer.facebookAria': 'Facebook（於新視窗開啟）',
    'footer.youtubeAria': 'YouTube（於新視窗開啟）',
    'footer.promo.brandName': '家庭友善企業',
    'footer.promo.brandEn': 'Family-Friendly Employers',
    'footer.promo.slogan': '"尋找並致敬真正支持家庭、關愛社會的企業"',
    'footer.promo.org':
      '主辦方：家庭友善企業評選組委會 · 聯繫郵箱 ffe-contact@genovationfoundation.org',
  },
  en: {
    // Navigation
    'nav.title': 'Genovation Foundation',
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.projects': 'Projects',
    'nav.news': 'News',
    'nav.report': 'Public Report',
    'nav.apply': 'Apply',
    'nav.apply.short': 'Apply',
    'nav.register': 'Register Now',
    'nav.register.short': 'Register',
    'nav.login': 'Log In',
    'nav.login.short': 'Log In',
    'nav.enterprise.overview': 'Overview',
    'nav.enterprise.companyInfo': 'Company Info',
    'nav.enterprise.logout': 'Logout',
    'nav.familyFriendly': 'Family-Friendly Employers',
    'nav.postgraduate': 'PhD Funding',

    // Language selector
    'lang.simplified': '简',
    'lang.traditional': '繁',
    'lang.english': 'EN',

    // Footer
    'footer.copyright': 'Copyright © 2025 Genovation Foundation Limited. All rights reserved',
    'footer.followUs': 'Follow Us',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',
    'footer.cookie': 'Cookie Policy',
    'footer.facebookAria': 'Facebook (opens in a new tab)',
    'footer.youtubeAria': 'YouTube (opens in a new tab)',
    'footer.promo.brandName': 'Family-Friendly Enterprise',
    'footer.promo.brandEn': 'Family-Friendly Employers',
    'footer.promo.slogan':
      '"Finding and honoring enterprises that truly support families and contribute to society"',
    'footer.promo.org':
      'Organizer: Family-Friendly Enterprise Selection Committee · ffe-contact@genovationfoundation.org',
  },
};
